import { Outlet, Navigate } from "react-router-dom";
import { useTokenRefresh } from "../hooks/useTokenRefresh";

function parseJwt(token) {
  const parts = token.split(".");
  if (parts.length !== 3) throw new Error("Invalid JWT format");
  const base64 =
    parts[1].replace(/-/g, "+").replace(/_/g, "/") +
    "==".slice(2 - (parts[1].length % 4));
  const json = decodeURIComponent(
    atob(base64)
      .split("")
      .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
      .join("")
  );
  return JSON.parse(json);
}

/** Token'daki adminName claim'i (V-Pay'de firma kodu olarak kullanılıyor). */
export function getAdminName() {
  const token = localStorage.getItem("authToken");
  if (!token) return null;
  try {
    return parseJwt(token).adminName ?? null;
  } catch {
    return null;
  }
}

const checkAuth = () => {
  const token = localStorage.getItem("authToken");
  const companyName = localStorage.getItem("companyName");


  // No token - not authenticated
  if (!token) {
    return { authenticated: false, hasValidClient: false, missingAdminName: false };
  }

  // Token'da adminName kontrolü
  try {
    const decoded = parseJwt(token);
    // const clientRoles = companyName
    //   ? decoded.resource_access?.[companyName]?.roles || []
    //   : [];

    // console.info("[AuthDebug][ProtectedRoutes] Token kullanıcı bilgileri", {
    //   adminName: decoded.adminName ?? null,
    //   // admin_name: decoded.admin_name ?? null,
    //   preferredUsername: decoded.preferred_username ?? null,
    //   email: decoded.email ?? null,
    //   companyName: companyName ?? null,
    //   projectCode: localStorage.getItem("projectCode") ?? null,
    //   clientRoles,
    //   realmRoles: decoded.realm_access?.roles || [],
    //   tokenClaimKeys: Object.keys(decoded).sort(),
    //   hasAdminName: Boolean(decoded.adminName),
    // });

    if (!decoded.adminName) {
      // console.warn(
      //   "[AuthDebug][ProtectedRoutes] adminName claim bulunamadı; kullanıcı login ekranına yönlendirilecek.",
      //   {
      //     fallbackUsername:
      //       decoded.preferred_username ?? decoded.email ?? null,
      //     companyName: companyName ?? null,
      //     clientRoles,
      //   },
      // );
      return { authenticated: false, hasValidClient: false, missingAdminName: true };
    }
  } catch {
    // console.error("[AuthDebug][ProtectedRoutes] JWT çözümlenemedi", {
    //   message: e instanceof Error ? e.message : String(e),
    // });
    return { authenticated: false, hasValidClient: false, missingAdminName: true };
  }

  // Token exists, check for valid client
  if (!companyName || companyName === "DefaultClient") {
    return { authenticated: true, hasValidClient: false, missingAdminName: false };
  }

  // Check if companyName has corresponding data in localStorage
  const companyData = localStorage.getItem(companyName);
  if (!companyData) {
    return { authenticated: true, hasValidClient: false, missingAdminName: false };
  }

  return { authenticated: true, hasValidClient: true, missingAdminName: false };
};

const ProtectedRoutes = () => {

  // Token yenileme mekanizmasını başlat
  useTokenRefresh();

  const { authenticated, hasValidClient, missingAdminName } = checkAuth();

  
  if (!authenticated || missingAdminName) {
    if (missingAdminName) {
    } else {
    }
    
  }

  return <Outlet />;
};

export default ProtectedRoutes;
